<template>
    <FormDialog
        :is-visible="isVisible" @abort="finish" @save="save"
        :title="model?.id ? 'Изменение пользователя' : 'Новый пользователь'"
    >
        <UserForm v-if="model" v-model="model" :errors="errors" />
    </FormDialog>
</template>

<script lang="ts">
import Component from 'vue-class-component'
import Editor from '@/mixins/Editor'
import FormDialog from '@/components/common/FormDialog.vue'
import UserForm from '@/components/forms/UserForm.vue'
import {User, UserDraft} from '@/models/User'

@Component({
    components: {UserForm, FormDialog},
})
export default class UserEditor extends Editor<User, UserDraft>
{
    async saveModel(user: UserDraft): Promise<User> {
        return await this.api.setUser(user)
    }

    getModelSavedMessage(user: User): string {
        return `Пользователь «${user.username}» сохранён`
    }
}
</script>
